import { connectRefinementList } from 'react-instantsearch-dom'

import { ProductFilterV1RefinementList } from './ProductFilterV1RefinementList'

const MultipleSelectionList = props => (
  <ProductFilterV1RefinementList {...props} />
)

MultipleSelectionList.propTypes = {
  ...ProductFilterV1RefinementList.propTypes,
}

MultipleSelectionList.defaultProps = {
  ...ProductFilterV1RefinementList.defaultProps,
}

export default connectRefinementList(MultipleSelectionList)
